function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import typography from '../utils/typography';
var useStyles = _ref => {
  var {
    isSinglePage,
    theme
  } = _ref;
  return React.useMemo(() => {
    var ACTION_BUTTON_SIZE = '36px';
    return {
      root: _objectSpread(_objectSpread(_objectSpread({
        color: theme.palette.foreground.default,
        display: 'table-row-group'
      }, typography(theme).label), isSinglePage && {
        boxSizing: 'border-box',
        display: 'block',
        overflowX: 'hidden',
        overflowY: 'auto'
      }), {}, {
        '> tr:hover': {
          '> td > button': {
            opacity: 1
          }
        }
      }),
      noItems: {
        avatar: {
          backgroundColor: theme.palette.background.disabled,
          margin: 'auto',
          marginBottom: theme.orbitalTwo,
          '> svg': {
            fill: theme.palette.foreground.default
          }
        },
        cell: {
          backgroundColor: theme.palette.background.container,
          display: isSinglePage ? 'block' : undefined,
          height: '100px',
          textAlign: 'center'
        },
        row: {
          border: 0
        },
        div: {
          display: 'inline-block'
        }
      },
      actionButton: open => ({
        opacity: open ? 1 : 0,
        transition: 'opacity 150ms ease',
        ':focus': {
          opacity: 1
        }
      }),
      actionCell: _objectSpread({
        maxWidth: ACTION_BUTTON_SIZE,
        minWidth: ACTION_BUTTON_SIZE,
        position: 'sticky',
        right: "calc(".concat(theme.orbitalFour, "/2)"),
        verticalAlign: 'middle',
        width: isSinglePage ? ACTION_BUTTON_SIZE : '1%'
      }, isSinglePage && {
        marginTop: "calc(-".concat(ACTION_BUTTON_SIZE, "/2)"),
        position: 'absolute',
        top: '50%'
      }),
      avatarSkeleton: {
        margin: theme.orbitalTwo
      },
      multiSelectSkeleton: {
        margin: theme.orbitalThree
      }
    };
  }, [isSinglePage, theme]);
};
export default useStyles;